import React from 'react';
export default function Placeholder() {
    return React.createElement("span", null);
}
//# sourceMappingURL=placeholder.js.map